import React from 'react';
import PropTypes from 'prop-types';

const FunctionalHeaderCell = ({ header }) => header();

FunctionalHeaderCell.propTypes = {
  /** The function used to render this cell  */
  header: PropTypes.func
};

FunctionalHeaderCell.defaultProps = {
  header: () => <span />
};

export default FunctionalHeaderCell;
